import { render, staticRenderFns } from "./ModalMrcTransfer.vue?vue&type=template&id=cc328266&scoped=true&"
import script from "./ModalMrcTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalMrcTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ModalMrcTransfer.vue?vue&type=style&index=0&id=cc328266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc328266",
  null
  
)

export default component.exports